module.exports = __webpack_public_path__ + "img/checkbox-default-disabled.adf6df1.svg";